import { AutocompleteFactory } from '../autocomplete/AutocompleteFactory';

/**
 * Main entry point for MA command line autocompletion
 * delegating logic to version-specific strategies.
 */
export const getCompletionItems = (model, position, keywordsData, version, monaco) => {
    try {
        if (!monaco) return { suggestions: [] };

        // Create the strategy using the factory
        const strategy = AutocompleteFactory.create(version, keywordsData, monaco);

        // Delegate execution to the strategy
        return strategy.getCompletionItems(model, position);

    } catch (e) {
        console.error("Critical error in getCompletionItems:", e);
        return { suggestions: [] };
    }
};
